<template>
    <div class="app-main customs">
        <div class="top-bar">
            <el-input v-model="batch" class="m-width-4 m-right-3">
                <template slot="prepend">批次</template>
            </el-input>   
            <el-input v-model="box" class="m-width-3 m-right-3">
                <template slot="prepend">箱号</template>
            </el-input>   
            <el-input v-model="barcode" class="m-width-4 m-right-3">
                <template slot="prepend">SKU</template>
            </el-input> 
            <el-input v-model="number" class="m-width-3 m-right-3" @keydown.enter.native="start()">
                <template slot="prepend">数量</template>
            </el-input> 
            <el-button @click="start()" type="success" plain class="m-right-4" style="width:120px">盘点</el-button>         
            <el-button @click="handleConfirm()" type="danger" plain style="width:120px">盘点确认</el-button>
        </div>



        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table  :data="tableData" empty-text="暂无盘点数据" height="600" style="width: 100%">
                <el-table-column prop="purchase_pic_url" label="商品图片"   align="center"  >
                    <template slot-scope="scope">
                        <table-img :src="scope.row.purchase_pic_url"></table-img>
                    </template>
                </el-table-column>
                <el-table-column prop="barcode"         label="条形码"     align="center"  min-width="140"> </el-table-column>
                <el-table-column prop="purchase_title"  label="商品名称"   align="center"  show-overflow-tooltip></el-table-column>
                <el-table-column prop="batch"           label="批次"       align="center"  ></el-table-column>
                <el-table-column prop="box"             label="箱号"       align="center"  ></el-table-column>
                <el-table-column prop="attr_symbol_string" label="规格属性"   align="center" >
                    <template slot-scope="scope" v-if="scope.row.attr_symbol_string">    
                        <el-tag size="medium" class="m-right-3">{{scope.row.attr_symbol_string}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="to_number"          label="盘点数量"   align="center"  ></el-table-column>
                
                <el-table-column prop="created_at"         label="入库时间"   align="center"  min-width="160"></el-table-column>
                <el-table-column prop="checknum"           label="编辑"       align="center"  >
                    <template slot-scope="scope">
                        <p><el-button type="danger" plain size="mini" @click="handleDel(scope.row)">数量减一</el-button></p>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        


    </div>
</template>

<script>
import { customs_get, customs, customs_del, customs_ok } from '@/api/warehouse.js'
import tableImg from '@/components/Image.vue'

export default {
    components:{ tableImg },
    data() {
        return {
            batch:'',
            box:'',
            barcode:'',
            number: '',
            tableData:[],          
        }
    },
    methods: {
        getData(){
            customs_get(0).then(res => {
                if(res){
                    this.tableData = res.data
                }else{
                    this.tableData = []
                }
            })
        },
        start(){
            
            if(this.batch === ""){
                this.$message.error("请完善商品批次...")
                return false
            }
            if(this.box === ""){
                this.$message.error("请完善箱号...")
                return false
            }
            if(this.barcode === ""){
                this.$message.error("请完善商品条形码...")
                return false
            }
            if(this.number === ""){
                this.$message.error("请完善商品数量")
                return false
            }
            let params = {
                batch:this.batch,
                box:this.box,
                barcode:this.barcode,
                number: this.number,
            }
            customs(params).then(res => {
                if(res){
                    this.$message({type:'success', message:res.msg, duration:1500})
                    this.barcode = ""
                    this.number = ""
                    this.getData()
                }
            })
        },
        // 盘点确认
        handleConfirm(){
            customs_ok().then(res => {
                if(res){
                    this.$message({type:'success', message:res.msg, duration:1500})
                    this.barcode = ""
                    this.number = ""
                    this.getData()
                }
            })
            
        },
        handleDel(row){
            let params = {
                barcode: row.barcode,
                batch: row.batch,
                box: row.box
            }
            console.log(params)
            customs_del(params).then(res => {
                if(res){
                    this.$message({type:'success', message:res.msg, duration:1500})
                    this.getData()
                }
            })
        },
        
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .input-box {
        display: inline-block;
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        box-sizing: border-box;
        color: #606266;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        width: 200px;
        vertical-align: top;
        position: relative;
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        &>div{
            display: flex;
            align-items: center;
            justify-content: center;
             border-radius: 4px;
            &>input {
                height: 35px;
                border: none;
                width: 94px;
                padding: 0 10px;
                box-sizing: border-box;
                text-align: center;
                -webkit-appearance: none;
                background-color: #FFF;
                background-image: none;
                color: #606266;
                font-size: 14px;
                 border-radius: 4px;
            }
             &>input::-webkit-input-placeholder{
                 color:#C0C4CC;
                 font-size:15px;
                 letter-spacing: 0;
            } 
            &>input:-moz-placeholder{
                color:#C0C4CC;
                font-size:16px;
                letter-spacing: 0;
            }
            &>input::moz-placeholder{
                color:#C0C4CC;
                font-size:16px;
                letter-spacing: 0;
            }
            &>input:-ms-input-placeholder{
                color:#C0C4CC;
                font-size:16px;
                letter-spacing: 0;
            }
            &>span{
                display: inline-block;
                width:10px;
            }
            &>input:focus {
                border: none;
                outline: none;
                
            }
        }
        
    }
    .input-box:focus-within {
        border-color:#409EFF !important;
    }
    .input-box:hover {
        border-color: #C0C4CC;
    }
}

</style>
